module.exports = __webpack_public_path__ + "img/person-green.1ff1a604.svg";